import { useState, useEffect, Fragment } from 'react';
import { Box, Link, Card, CardContent, Divider } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { SttDialog } from '../../../sporttia/dialogs/SttDialog';

type LinkItem = {
    caption: string;
    content: React.ReactElement<{ onClose?: () => void }>;
    icon?: React.ReactElement;
};

type Props = {
    items?: LinkItem[];
};

export default function SttLinkList({
    items,
}: Props): React.ReactElement | null {
    const [open, setOpen] = useState<boolean>(false);
    const [viewContent, setViewContent] = useState<React.ReactElement | null>(
        null,
    );

    useEffect(() => {
        setOpen(viewContent !== null);
    }, [viewContent]);

    // Nothing to render
    if (!items) {
        return null;
    }

    return (
        <>
            <Box mt={3}>
                <Card variant="outlined">
                    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                        {items.map((item: any, i: any) => (
                            <Fragment key={i}>
                                {i > 0 && <Divider />}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        p: 2,
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                        '&:hover': {
                                            bgcolor: 'action.hover',
                                        },
                                    }}
                                    onClick={() =>
                                        setViewContent(
                                            // Interceptamos el item para clonarlo añadiéndole un prop onClose, que llama al onClose original del item (si existe) antes de cerrar el modal general. Parece magia negra porque, de hecho, lo es.
                                            <item.content.type
                                                {...item.content.props}
                                                onClose={() => {
                                                    item.content.props.onClose?.();
                                                    setViewContent(null);
                                                }}
                                            />,
                                        )
                                    }
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                        }}
                                    >
                                        {item.icon && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    color: 'var(--brand-text)',
                                                }}
                                            >
                                                {item.icon}
                                            </Box>
                                        )}
                                        <Link
                                            sx={{
                                                color: 'var(--brand-text)',
                                                textDecoration: 'none',
                                                fontWeight: 500,
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                            component="span"
                                        >
                                            {item.caption}
                                        </Link>
                                    </Box>
                                    <ChevronRight
                                        sx={{
                                            color: 'action.active',
                                            ml: 1,
                                        }}
                                    />
                                </Box>
                            </Fragment>
                        ))}
                    </CardContent>
                </Card>
            </Box>
            <SttDialog
                open={open}
                onClose={() => setOpen(false)}
                title={undefined}
                content={viewContent}
                buttons={[
                    {
                        type: 'close',
                        onClick: () => setOpen(false),
                    },
                ]}
            />
        </>
    );
}
